import { Box } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkButton from "../../components/atoms/TkButton";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkStepper from "../../components/atoms/TkStepper";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkDataTable from "../../components/molecules/TkDataTable";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import "./_style.scss";
import { httpIAPI_CON010 } from "./api/request";
import {
  infoHeadTitleList,
  infoManual1,
  infoManual2,
  stepperData,
} from "./parts";

/**
 * SCRC050107 契約解除（経営者でなくなった）対象施設一覧
 * @return SCRC050107 契約解除（経営者でなくなった）対象施設一覧
 */
const SCRC050107 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext<any>(BusinessContext);
  const [infoTableList, setInfoTableList] = useState<any>({
    infoHeadTitleList: infoHeadTitleList,
  });
  const facilities = useRef<any>([]); //施設一覧
  const [isNextBtnDisabled, setIsNextBtnDisabled] = useState(false); //次へボタンの活性非活性

  //初期表示API取得結果
  // const [apiGetData, setApiGetData] = useState<IAPI_CON010_Response>(); // TODO 課題584

  const userType = state?.authInfo?.userType;
  const isKiko = userType === authorityUserType.userTypeNumber.KIKO;
  const contractorNo = isKiko
    ? businessState.common?.contractorNo
    : state.authInfo?.contractorNo!;
  const businessType = "job_02";
  const applyId = businessState?.[businessType]?.applyId;

  // 初期化
  const handleInit = async () => {
    try {
      const res = (await httpIAPI_CON010({
        contractorNo,
        applyId,
      })) as { [key: string]: any };

      if (res.resultCd === "I0000") {
        // setApiGetData(res);
        const infoBodyList = getTableBodyList(res.facilityList);
        setIsNextBtnDisabled(
          res.facilityList.some((f: any) => f.processStatus === "未登録")
        );
        facilities.current = res.facilityList;
        const data = {
          infoHeadTitleList: infoHeadTitleList,
          infoBodyList: infoBodyList,
        };
        setInfoTableList(data);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    //ユーザータイプが機構の場合
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setInfoTableList]);

  /**
   * 施設一覧テーブルを作成する
   * @param facilityList
   * @returns infoBodyList
   */
  function getTableBodyList(facilityList: any) {
    const infoBodyList = facilityList?.map((item: any) => [
      {
        id: item.facilityNo,
      },
      {
        children: (item.facilityNo ?? "") + ":" + (item.facilityName ?? ""),
        forSort: item.facilityNo,
      },
      {
        children: item.facilityKindName ?? "",
        forSort: item.facilityKindName,
      },
      {
        children: item.processStatus,
        forSort: item.processStatus,
      },
      {
        children: (
          <Box className="SCRC050107RegButtonCol">
            <TkButton
              data-testid="SCRC050107ResisterButton"
              onClick={() => handleResister(item.facilityNo)}
            >
              登録
            </TkButton>
          </Box>
        ),
        className: "SCRC050107TableButtonClomun",
      },
    ]);

    return infoBodyList ?? [];
  }

  //登録ボタン用イベント
  const handleResister = (facilityNo: any) => {
    navigate("/SCRC050108", {
      state: {
        //施設番号
        facilityNo,
      },
    });
  };

  // 遷移先と持回り情報
  function nav() {
    navigate("/SCRC050009", {
      state: {
        facilityList: facilities.current,
      },
    });
  }

  return (
    <Box data-testid="SCRC050107test" className="SCRC050107">
      <TkStepper
        steps={stepperData}
        activeStep={1}
        savaStep={businessState[""] - 1}
      />
      <TkInfoManual rule={"<"}>{infoManual1}</TkInfoManual>

      {userType === authorityUserType.userTypeNumber.KIKO && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={`${businessState.common?.contractorNo ?? ""}:${
            businessState.common?.contractorName ?? ""
          }`}
        />
      )}
      <TkDataTable
        bodyList={infoTableList.infoBodyList}
        count={6}
        defaultRowsPerPage={5}
        headList={infoTableList.infoHeadTitleList}
        pagin
      />
      <TkInfoManual rule={"<"}>{infoManual2}</TkInfoManual>
      <Box className="SCRC050107ButtonRow">
        <TkBackButton />
        <TkButton onClick={() => nav()} disabled={isNextBtnDisabled}>
          次へ
        </TkButton>
      </Box>
    </Box>
  );
};

export default SCRC050107;
